import CardHoverInfo from '../CardHoverInfo';
import TarotCard from '../TarotCard';
import './SingleCardSpread.css';

/** The one-card layout: the card alone, named once it is turned. */
function SingleCardSpread({ cards, revealed, onReveal }) {
  const card = cards[0];
  const isRevealed = revealed.includes(0);

  // Empty until the card is picked from the fan
  if (!card) return <div className="single-card-layout" />;

  return (
    <div className="single-card-layout">
      <div
        className={`card-container ${isRevealed ? 'revealed' : ''}`}
        onClick={() => onReveal(0)}
      >
        <CardHoverInfo card={card}>
          <TarotCard card={card} isRevealed={isRevealed} />
        </CardHoverInfo>
        {isRevealed && (
          <div className="card-name">{card.name}</div>
        )}
      </div>
    </div>
  );
}

export default SingleCardSpread;
